import { render } from "./OrthoLogin.vue?vue&type=template&id=10e69899&scoped=true"
import script from "./OrthoLogin.vue?vue&type=script&lang=js"
export * from "./OrthoLogin.vue?vue&type=script&lang=js"

import "./OrthoLogin.vue?vue&type=style&index=0&id=10e69899&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e69899"]])

export default __exports__